import { Injectable } from '@angular/core';
import {
    HttpRequest,
    HttpHandler,
    HttpEvent,
    HttpInterceptor,
    HttpErrorResponse
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { Router } from '@angular/router';
import { SessionService } from './shared/services/session.service';

@Injectable({
  providedIn: 'root'
})

export class TokenInterceptorService implements HttpInterceptor {

  constructor(private router: Router,private sessionService: SessionService) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
      const currentUser = JSON.parse(localStorage.getItem('currentUser'));
      if (currentUser && currentUser.token) {
        request = request.clone({
            setHeaders: {
                'Content-Type': 'application/json',
                Authorization: 'Bearer ${currentUser.token}'
            }
        });
      }
      return next.handle(request).pipe( tap(() => {},
      (err: any) => {
          if (err instanceof HttpErrorResponse) {
              if (err.status !== 401) {
                  return;
              }
              this.sessionService.logOff();
          }
      }
      ));
  }
}
